import { DiTokens } from "../../services/diTokens";
import { Watch } from "vue-property-decorator";
import IPersonService from "../../services/person/IPersonService";
import authHistorySource from "../../filters/authHistorySource.filter";
import { AuthorizationsHistoryData } from "../../data/authorizationsHistoryData";
import { AuthHistorySources } from "../../data/enums/authHistorySources";
import { container } from "@/inversify.config";
import Vue from "vue";

/**
 *  Класс для компоненты истории посещений.
 */
export class AuthHistoryVue extends Vue {

  /**
 * Сервис полльзователя
 * @returns {IPersonService}
 */  
  get personService(): IPersonService {
    return container.get<IPersonService>(DiTokens.PersonService);
  }

  /** Период месяцев */
  months: Array<any> = [];

  /** Флаг скрывания пикера */
  showPicker: boolean = false;

  take: number = 20;

  skip: number = 0;

  /** Отслеживание изменения значение периода месяцев */
  @Watch("months", { immediate: true })
  async monthsChanged() {
    if (this.months.length > 0) {
      if (new Date(this.months[0]) > new Date(this.months[1])) {
        const boofer = this.months[0];
        this.months[0] = this.months[1];
        this.months[1] = boofer;
      }
      await this.getHistory(false);
    }
  }

  /** Массив посещений */
  history: Array<AuthorizationsHistoryData> = [];

  /** Признак загрузки */
  loading: boolean = true;

  /** Получение истории посещений */
  async getHistory(more: boolean) {
    
    this.loading = true;
    const res = await this.personService.getAuthorizationsHistory(
      this.take,
      this.skip,
      this.months[0],
      this.months[1]
    );
    if (more) {
      this.skip += this.take;
      res.map((item: any) => {
        this.history.push(item);
      });
    } else {
      this.history = res;
    }
    this.loading = false;
  }

  /** Показывать кнопку "Показать еще" */
  get showBtnHistory() {
    if (this.history.length >= this.skip) {
      return true;
    }
    return false;
  }

  /** Изменение значения периода */
  changeMonthVal(e: any) {
    this.months = e.period;
  }

  /** Изменение значения флага пикера */
  togglePicker() {
    this.showPicker = !this.showPicker;
  }

  /** Получение периода дат в текстовом формате */
  get periodText() {
    if (this.months.length > 0) {
      const first = this.months[0]?.split('-').reverse().join(".");
      const second = this.months[1]?.split('-').reverse().join(".");

      return `${first ? first : ''}${first && second ? ' - ' : ''}${second ? second : ''}`;
    }
    return "";
  }

  /** Обновить данные */
  async refreshList(e: any) {
    e.stopPropagation();
    this.skip = 0;
    this.getHistory(true);
    this.getHistory(false);
  }

  /** Максимальная дата запроса */
  get getMaxDate(): string {
    return new Date().toISOString().substr(0, 10);
  }

  /** Инициализация компоненты */
  async init() {
    const first = this.getMaxDate.substring(0, 8) + "01";
    this.months.push(first);
    this.months.push(this.getMaxDate);    
    await this.getHistory(true);
  }

  getSource(source: AuthHistorySources) {
    return authHistorySource(source);
  }
}
